import axios from 'axios'
import requestMixin from './requestMixin'
const { setupCache } = window.AxiosCacheInterceptor

const baseURL = process.env.VUE_APP_BASE_API
const service = axios.create({
  baseURL,
  method: 'post',
  timeout: 30000 // request timeout
})

const http = setupCache(service, {
  ttl: 5 * 1000,
  methods: ['post'],
  interpretHeader: false,
  cachePredicate: {
    statusCheck: (status) => status === 200
  }
})

requestMixin(service, baseURL)

export default http
